"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutDeliveryController = void 0;
var _auth = require("@ori/auth");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _defaultTranslations = require("./constants/defaultTranslations");
var _contexts = require("./contexts");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutDeliveryController = ({
  configuration
}) => {
  const {
    shoppingContext: {
      customerId = _auth.NOT_LOGGED_IN_USER_ID,
      sessionId = ''
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const wasNavigationToNextStep = (0, _react.useRef)(false);

  // analytics
  const currentCourierName = (0, _react.useRef)(undefined);
  const isAddingNewDelivery = (0, _react.useRef)(false);
  const originalCourierName = (0, _react.useRef)(undefined);
  const originalSelectedDeliveryItem = (0, _react.useRef)(undefined);
  const analyticsData = {
    currentCourierName,
    isAddingNewDelivery,
    originalCourierName,
    originalSelectedDeliveryItem
  };
  const {
    token
  } = (0, _auth.useToken)();
  const isReadyToGo = typeof customerId !== 'number' ? false : (0, _auth.isTokenValid)(token);
  if (!isReadyToGo || !sessionId) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.StrictMode, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        areaName: `${_constants.APP_NAME}-boundary`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
          team: _testidGenerator.Team.Checkout,
          project: _constants.APP_NAME,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.CheckoutDeliveryProvider, {
            value: {
              ...configuration,
              customerId,
              sessionId
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _defaultTranslations.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.NextStepNavigationProvider, {
                value: {
                  wasNavigationToNextStep
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.AnalyticsProvider, {
                  value: analyticsData,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.CheckoutDelivery, {})
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.CheckoutDeliveryController = CheckoutDeliveryController;